import React from 'react';
import { styled } from '@mui/material';

import { Box, Container, Tabs } from 'shell/components';

const Desktop = ({ options, tab, setTab }) => {
    return (
        <Container device={'desktop'}>
            <RootBox>
                <Tabs aria-label={'select members or teams'} options={options} selected={tab} onChange={setTab} />
            </RootBox>
        </Container>
    );
};

const RootBox = styled(Box)(({ theme }) => {
    return {
        borderRadius: '12px 12px 0 0',
        width: '100%',
        minHeight: 'calc(100vh - 64px - 20px)',
        padding: theme.spacing(5, 5, 0),
        background: theme.palette.ensightful.shades[0],
    };
});

export default Desktop;
